import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';

import Styles from './styles.module.scss';

const CustomTweetsComponent = ({ item, url }) => {
  const getUpdatedString = (string) => (string || '')
    .split('<a href=').join('<a target="_blank" rel="noopener noreferrer" href=');

  return (
    <a
      className={Styles.custom_tweet}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => { e.stopPropagation(); }}
    >
      <div className={Styles.custom_tweet_icon}>
        <FontAwesomeIcon icon={faTwitter} />
      </div>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: getUpdatedString(item) }} />
    </a>
  );
};

export default CustomTweetsComponent;
